import { initContract } from "@ts-rest/core";
import { Request } from "./request.js";
import { Err, Ok } from "./response.js";

export const contract = initContract().router({
  holdings: {
    method: "GET",
    path: "/physical-stock/holdings",
    responses: {
      [200]: Ok,
      [500]: Err,
    },
    query: Request,
    summary: "Gets physical stock holdings based on some query parameters.",
  },
});
